import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { UserButton, SignedIn, SignedOut } from '@clerk/clerk-react';
import '../App.css';
import logo from '../images/logo.png';

const Navbar = ({ jobsCount, onLogoClick }) => {
  const navigate = useNavigate();
  
  return (
    <div className="navbar">
      <div className="navbar-container">
        <div className="navbar-content">
          {/* Logo Section */}
          <Link to="/" onClick={onLogoClick} className="navbar-brand">
            <img 
              src={logo} 
              alt="AlgoHeads Logo" 
              className="navbar-logo-img"
              width="32" 
              height="32" 
            />
            <span className="brand-text">
              AlgoHeads<span className="brand-domain">.com</span>
            </span>
          </Link>
          
          {/* Right Section */}
          <div className="navbar-right">
            
            
            {/* Pricing always visible */}
            <Link to="/pricing" className="navbar-pricing">
              Pricing
            </Link>
            
            {/* Blogs link */}
            <Link to="/blogs" className="navbar-pricing">
              Blogs
            </Link>
            
            {/* Waitlist link */}
            <a 
              href="https://getwaitlist.com/waitlist/27552" 
              target="_blank" 
              rel="noopener noreferrer"
              className="navbar-pricing waitlist-button"
            >
              Waitlist
            </a>
            
            <SignedIn>
              <div className="user-button-container">
                <UserButton afterSignOutUrl="/" />
              </div>
            </SignedIn>
            
            <SignedOut>
              <button
                onClick={() => navigate('/sign-in')}
                className="navbar-sign-in"
              >
                Sign In
              </button>
            </SignedOut>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;